module.exports = __webpack_public_path__ + "img/video.32227446.png";